/** @jsx jsx */
import { jsx, Box, Styled, Flex, useThemeUI } from "theme-ui"
import React, { useState } from "react"
import { motion } from "framer-motion"
import { tint } from "polished"

const Plus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    sx={{ display: "block" }}
  >
    <path fill="currentColor" d="M9 16V9h7V7H9V0H7v7H0v2h7v7z" />
  </svg>
)

const Accordion = ({ title, content, index, ...props }) => {
  const [expanded, setExpanded] = useState(false)
  const ariaControlId = `accordion-${index}`
  const { theme } = useThemeUI()
  return (
    <Box
      sx={{
        boxShadow: `inset 0 -1px 0 ${tint(0.75, theme.colors.text)}`,
      }}
      {...props}
    >
      <Flex
        onClick={() => setExpanded(expanded ? false : true)}
        role="button"
        aria-controls={ariaControlId}
        aria-expanded={expanded}
        variant="plain"
        sx={{
          py: 3,
          width: "100%",
          color: "text",
          alignItems: "center",
          justifyContent: "space-between",
          whiteSpace: "normal",
          textAlign: "left",
          cursor: "pointer",
          ":hover": { color: "text" },
        }}
      >
        <Box
          as={motion.header}
          initial={false}
          sx={{
            fontFamily: "heading",
            fontWeight: "heading",
            letterSpacing: "heading",
            fontSize: [3, 4],
          }}
        >
          {title}
        </Box>
        <motion.div
          style={{
            flex: "none",
            width: 16,
            height: 16,
            marginRight: 8,
            transformOrigin: "center center",
            color: tint(0.25, theme.colors.text),
          }}
          animate={{ transform: expanded ? "rotate(45deg)" : "rotate(0deg)" }}
        >
          <Plus />
        </motion.div>
      </Flex>
      <motion.section
        key="content"
        initial="collapsed"
        animate={expanded ? "open" : "collapsed"}
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: "auto", display: "block" },
          collapsed: {
            opacity: 0,
            height: 0,
            overflow: "hidden",
            transitionEnd: {
              display: "none",
            },
          },
        }}
        transition={{ duration: 0.3, ease: [0.04, 0.6, 0.2, 1] }}
        id={ariaControlId}
      >
        <motion.div
          variants={{ collapsed: { scale: 0.9 }, open: { scale: 1 } }}
          transition={{ duration: 0.15 }}
        >
          {content}
        </motion.div>
      </motion.section>
    </Box>
  )
}
export default Accordion
